// LUMINA · pages/vajra/components/MyMandala.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, DG, PANEL } from '../constants';
import { today, fmt } from '../utils';
import { VajraInput, VajraBtn, ProgressBar } from '../primitives';
import EnergyDharmaWidget from './EnergyDharmaWidget';

export default function MyMandala({ token, member }) {
  const headers = {"Authorization":`Bearer ${token}`,"Content-Type":"application/json"};
  const [logs,   setLogs]   = useState([]);
  const [stats,  setStats]  = useState({});
  const [goals,  setGoals]  = useState([]);
  const [showLog, setShowLog] = useState(false);
  const [showGoal, setShowGoal] = useState(false);
  const [logForm, setLogForm] = useState({practice_type:"",count:"",duration_min:"",notes:"",logged_date:today()});
  const [goalForm, setGoalForm] = useState({practice_type:"",target_count:"",start_date:today(),end_date:""});
  const [msg, setMsg] = useState("");

  const load = useCallback(async () => {
    const [lr,sr,gr] = await Promise.all([
      fetch(`${API}/vajra/practice`,{headers}).then(r=>r.ok?r.json():[]),
      fetch(`${API}/vajra/practice/stats`,{headers}).then(r=>r.ok?r.json():{}),
      fetch(`${API}/vajra/goals`,{headers}).then(r=>r.ok?r.json():[]),
    ]);
    setLogs(lr); setStats(sr); setGoals(gr);
  }, [token]);

  useEffect(()=>{load();},[load]);

  const submitLog = async (e) => {
    e.preventDefault();
    const r = await fetch(`${API}/vajra/practice`,{method:"POST",headers,body:JSON.stringify({
      ...logForm, count:parseInt(logForm.count)||0, duration_min:parseInt(logForm.duration_min)||0
    })});
    if(r.ok){setMsg("已记录");setShowLog(false);setLogForm({practice_type:"",count:"",duration_min:"",notes:"",logged_date:today()});load();}
  };

  const submitGoal = async (e) => {
    e.preventDefault();
    const r = await fetch(`${API}/vajra/goals`,{method:"POST",headers,body:JSON.stringify({
      ...goalForm, target_count:parseInt(goalForm.target_count)||0
    })});
    if(r.ok){setShowGoal(false);setGoalForm({practice_type:"",target_count:"",start_date:today(),end_date:""});load();}
  };

  const activeGoals = goals.filter(g=>g.is_active);
  const doneGoals   = goals.filter(g=>!g.is_active);

  return (
    <div style={{padding:"24px 0"}}>
      {msg&&<div style={{fontSize:13,color:DG,marginBottom:12,padding:"6px 12px",background:"rgba(6,78,59,0.06)",borderRadius:6}}>{msg}</div>}

      {/* Greeting */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:20,color:"#2d2d2d"}}>
          {member?.dharma_name ? `${member.dharma_name} 师兄，吉祥如意` : (member?.name ? `${member.name} 师兄，吉祥如意` : "欢迎回来")}
        </div>
        <div style={{fontSize:13,color:"#aaa",marginTop:4}}>{today()} · 愿修行增上</div>
      </div>

      {/* 能量与实修对治 Widget */}
      <EnergyDharmaWidget member={member}/>

      {/* Accumulation Stats */}
      {Object.keys(stats).length > 0 && (
        <div style={{background:PANEL,borderRadius:12,padding:"20px 22px",marginBottom:20,border:`1px solid rgba(107,26,26,0.12)`}}>
          <div style={{fontSize:12,color:"#aaa",letterSpacing:1.5,textTransform:"uppercase",marginBottom:14}}>累积修行</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:12}}>
            {Object.entries(stats).map(([type,s])=>(
              <div key={type} style={{textAlign:"center",padding:"12px 8px",background:"rgba(107,26,26,0.04)",borderRadius:8}}>
                <div style={{fontSize:11,color:"#888",marginBottom:4,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{type}</div>
                <div style={{fontSize:22,color:GD,fontFamily:"'Inter',sans-serif"}}>{fmt(s.count)}</div>
                <div style={{fontSize:11,color:"#aaa"}}>{s.days} 天 · {s.duration_min} 分钟</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Active Goals */}
      {activeGoals.length > 0 && (
        <div style={{background:PANEL,borderRadius:12,padding:"20px 22px",marginBottom:20,border:`1px solid rgba(184,134,11,0.18)`}}>
          <div style={{fontSize:12,color:"#aaa",letterSpacing:1.5,textTransform:"uppercase",marginBottom:14}}>修行目标</div>
          {activeGoals.map(g=>(
            <div key={g.id} style={{marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6}}>
                <span style={{fontSize:14,color:"#333"}}>{g.practice_type}</span>
                <span style={{fontSize:12,color:GD}}>{fmt(g.current_count)} / {fmt(g.target_count)}</span>
              </div>
              <ProgressBar pct={g.pct} color={GD}/>
              {g.end_date&&<div style={{fontSize:11,color:"#aaa",marginTop:4}}>截止 {g.end_date}</div>}
            </div>
          ))}
        </div>
      )}

      {/* Action Buttons */}
      <div style={{display:"flex",gap:10,marginBottom:20}}>
        <VajraBtn onClick={()=>setShowLog(true)}>+ 记录修行</VajraBtn>
        <VajraBtn variant="outline" onClick={()=>setShowGoal(true)}>+ 设定目标</VajraBtn>
      </div>

      {/* Log Form */}
      {showLog&&(
        <div style={{background:PANEL,borderRadius:12,padding:"22px 22px",marginBottom:20,border:`1px solid rgba(139,105,20,0.10)`}}>
          <div style={{fontSize:15,color:GD,marginBottom:16}}>记录今日修行</div>
          <form onSubmit={submitLog}>
            <VajraInput label="修持法门" value={logForm.practice_type} onChange={v=>setLogForm({...logForm,practice_type:v})} placeholder="如：金刚萨埵心咒、大礼拜" required/>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <VajraInput label="数量（遍/次）" value={logForm.count} onChange={v=>setLogForm({...logForm,count:v})} type="number" placeholder="0"/>
              <VajraInput label="时长（分钟）" value={logForm.duration_min} onChange={v=>setLogForm({...logForm,duration_min:v})} type="number" placeholder="0"/>
            </div>
            <VajraInput label="日期" value={logForm.logged_date} onChange={v=>setLogForm({...logForm,logged_date:v})} type="date"/>
            <VajraInput label="备注（选填）" value={logForm.notes} onChange={v=>setLogForm({...logForm,notes:v})} placeholder="修行感悟…"/>
            <div style={{display:"flex",gap:8}}>
              <VajraBtn type="submit">提交</VajraBtn>
              <VajraBtn variant="outline" onClick={()=>setShowLog(false)}>取消</VajraBtn>
            </div>
          </form>
        </div>
      )}

      {/* Goal Form */}
      {showGoal&&(
        <div style={{background:PANEL,borderRadius:12,padding:"22px 22px",marginBottom:20,border:`1px solid rgba(184,134,11,0.2)`}}>
          <div style={{fontSize:15,color:GD,marginBottom:16}}>设定修行目标</div>
          <form onSubmit={submitGoal}>
            <VajraInput label="修持法门" value={goalForm.practice_type} onChange={v=>setGoalForm({...goalForm,practice_type:v})} placeholder="如：金刚萨埵心咒（21天）" required/>
            <VajraInput label="目标数量" value={goalForm.target_count} onChange={v=>setGoalForm({...goalForm,target_count:v})} type="number" placeholder="如：100000" required/>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <VajraInput label="开始日期" value={goalForm.start_date} onChange={v=>setGoalForm({...goalForm,start_date:v})} type="date"/>
              <VajraInput label="截止日期（选填）" value={goalForm.end_date} onChange={v=>setGoalForm({...goalForm,end_date:v})} type="date"/>
            </div>
            <div style={{display:"flex",gap:8}}>
              <VajraBtn variant="gold" type="submit">创建目标</VajraBtn>
              <VajraBtn variant="outline" onClick={()=>setShowGoal(false)}>取消</VajraBtn>
            </div>
          </form>
        </div>
      )}

      {/* Recent Logs */}
      {logs.length > 0 && (
        <div style={{background:PANEL,borderRadius:12,padding:"20px 22px",border:`1px solid rgba(0,0,0,0.06)`}}>
          <div style={{fontSize:12,color:"#aaa",letterSpacing:1.5,textTransform:"uppercase",marginBottom:14}}>近期记录</div>
          {logs.slice(0,10).map(l=>(
            <div key={l.id} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid rgba(0,0,0,0.04)",fontSize:13}}>
              <div>
                <span style={{color:"#333"}}>{l.practice_type}</span>
                {l.count>0&&<span style={{color:GD,marginLeft:8}}>{fmt(l.count)}遍</span>}
                {l.duration_min>0&&<span style={{color:"#aaa",marginLeft:6}}>{l.duration_min}分钟</span>}
              </div>
              <span style={{color:"#bbb",fontSize:12}}>{l.logged_date}</span>
            </div>
          ))}
        </div>
      )}

      {/* Completed Goals */}
      {doneGoals.length > 0 && (
        <div style={{marginTop:20,background:PANEL,borderRadius:12,padding:"20px 22px",border:`1px solid rgba(6,78,59,0.12)`}}>
          <div style={{fontSize:12,color:"#aaa",letterSpacing:1.5,textTransform:"uppercase",marginBottom:12}}>已完成目标</div>
          {doneGoals.map(g=>(
            <div key={g.id} style={{display:"flex",justifyContent:"space-between",fontSize:13,padding:"6px 0",borderBottom:"1px solid rgba(0,0,0,0.04)"}}>
              <span style={{color:"#666"}}>{g.practice_type}</span>
              <span style={{color:DG}}>✓ {fmt(g.target_count)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
